import { ProductFeature, UseFeatureFlagsReturnType } from '@localstack/types';

import { getPlaywrightFeatureFlagOverrides, FEATURE_FLAGS } from '@localstack/services';

import { useAuthProvider } from './useAuthProvider';

export const useFeatureFlags: () => UseFeatureFlagsReturnType = () => {
  const { isPlatformAdmin, hasFeature } = useAuthProvider();

  const defaultFlags: UseFeatureFlagsReturnType = {
    // only localstack org has this marker
    showNonAwsInstanceImages: hasFeature(ProductFeature.FEATURE_COMPUTE, 'non-aws-images'),
    showExtensionSubmission: isPlatformAdmin,
    ...FEATURE_FLAGS,
  };

  return {
    ...defaultFlags,
    ...getPlaywrightFeatureFlagOverrides(),
  };
};
